<div *ngFor="let video of videoTOs">
  <iframe
    *ngIf="video.videoType !== 'vimeo'"
    [src]="video.safeUrl"
    id="player"
    frameborder="0"
    width="100%"
    height="auto"
    allowfullscreen="allowfullscreen"
    mozallowfullscreen="mozallowfullscreen"
    msallowfullscreen="msallowfullscreen"
    oallowfullscreen="oallowfullscreen"
    webkitallowfullscreen="webkitallowfullscreen"
    allowFullScreen
  ></iframe>

  <div *ngIf="video.videoType === 'vimeo'" style="padding: 56.25% 0 12px 0; position: relative">
    <iframe
      [src]="video.safeUrl"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%"
      frameborder="0"
      allow="autoplay; fullscreen"
      allowfullscreen
    ></iframe>
  </div>
</div>
